import {
  IconCalendarEvent,
  IconBell,
  IconBuilding,
  IconCar,
  IconFileInvoice,
  IconLayoutDashboard,
  IconReceipt2,
  IconUserCircle,
  IconCurrencyEuro,
  IconUserShield,
  type Icon,
} from '@tabler/icons-react';

export interface NavItem {
  label: string;
  to: string;
  /** Selector estable para accesibilidad y agentes de navegador. */
  agentId: string;
  icon: Icon;
  /** Aún no portado desde admin_app (F2–F4). */
  comingSoon?: boolean;
}

/** Secciones del panel (paridad con las rutas activas de admin_app/GoRouter). */
export const NAV_ITEMS: NavItem[] = [
  {
    label: 'Dashboard',
    to: '/dashboard',
    agentId: 'admin.nav.dashboard',
    icon: IconLayoutDashboard,
  },
  { label: 'Mi cuenta', to: '/account', agentId: 'admin.nav.account', icon: IconUserCircle },
  { label: 'Tarifas', to: '/pricing', agentId: 'admin.nav.pricing', icon: IconCurrencyEuro },
  { label: 'Operadores', to: '/operators', agentId: 'admin.nav.operators', icon: IconBuilding },
  { label: 'Flota', to: '/fleet', agentId: 'admin.nav.fleet', icon: IconCar },
  { label: 'Servicios', to: '/services', agentId: 'admin.nav.services', icon: IconCar },
  { label: 'Notificaciones', to: '/notifications', agentId: 'admin.nav.notifications', icon: IconBell },
  {
    label: 'Reservas',
    to: '/reserves',
    agentId: 'admin.nav.reserves',
    icon: IconCalendarEvent,
  },
  {
    label: 'Nuevo servicio',
    to: '/new-service',
    agentId: 'admin.nav.new-service',
    icon: IconCar,
  },
  {
    label: 'Facturación',
    to: '/invoices',
    agentId: 'admin.nav.invoices',
    icon: IconFileInvoice,
  },
  {
    label: 'Contabilidad',
    to: '/accounting',
    agentId: 'admin.nav.accounting',
    icon: IconReceipt2,
  },
  {
    label: 'Gastos',
    to: '/expenses',
    agentId: 'admin.nav.expenses',
    icon: IconReceipt2,
    comingSoon: true,
  },
  { label: 'VTC', to: '/vtc', agentId: 'admin.nav.vtc', icon: IconCar },
  { label: 'Cumplimiento', to: '/compliance', agentId: 'admin.nav.compliance', icon: IconUserShield },
  {
    label: 'Solicitudes admin',
    to: '/admin-requests',
    agentId: 'admin.nav.admin-requests',
    icon: IconUserShield,
  },
];
